<template>
  <div class="container">
    <left-aslide :activeNum="'3'"></left-aslide>
    <body-layout>
      <template slot="page-header">
        <filter-layout>
          <template slot="filter-left">
            <span>发票信息</span>
          </template>
          <template slot="filter-right">
            <el-button type="primary" @click="addInvoice"
              >添加发票抬头</el-button
            >
          </template>
        </filter-layout>
      </template>
      <template slot="ebs-content">
        <div class="cardInfo" ref="cardInfo">
          <div v-for="item in cardDataList" :key="item.id" class="cardInfoItem">
            <el-card :class="['box-card']">
              <div class="pt-b-10">
                <span class="titleLabel">名称</span>
                <span>{{ item.invoiceTitle }}</span>
              </div>
              <div>
                <span class="titleLabel">税号</span>
                <span>{{ item.taxNumber }}</span>
              </div>
              <div class="pt-b-20">
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="editInvoice(item)"
                  icon="el-icon-edit" 
                  >修改</el-button
                >
                 <el-button
                      type="danger"
                      size="small"
                      plain
                      @click="removeInvoice(item)"
                      icon="el-icon-delete" 
                      >删除</el-button> 
              </div>
            </el-card>
          </div>
        </div>
      </template>
    </body-layout>
    <invoice-dialog
      ref="invoice"
      :title="title"
      :disabled="false"
      @submit="onSubmit"
    ></invoice-dialog>
  </div>
</template>

<script>
import invoiceDialog from '../orderLists/components/invoiceDialog'
import { queryInvoice, createInvoice, deleteInvoiceByTaxNumber } from '@/api/order'
import { cloneDeep } from 'lodash'
export default {
  name: 'invoiceIndex',
  components: {
    invoiceDialog,
  },
  data() {
    return {
      cardLoading: false,
      cardDataList: [],
      isEditInvoice: false,
    }
  },
  computed: {
    title() {
      return this.isEditInvoice ? '修改发票抬头' : '新增发票抬头'
    },
  },
  methods: {
    onSubmit(form) {
      return createInvoice(form).then((v) => {
        this.$message({
          type: 'success',
          message: '操作成功',
        })
        this.$refs.invoice.dialogVisible = false
        this.getDataList()
      })
    },
    getDataList() {
      return queryInvoice().then((v) => {
        this.cardDataList = v.data
      })
    },
    editInvoice(item) {
      this.isEditInvoice = true
      this.$nextTick(() => {
        this.$refs.invoice.init(cloneDeep(item))
        this.$refs.invoice.dialogVisible = true
      })
    },
    addInvoice() {
      this.isEditInvoice = false
      this.$nextTick(() => {
        this.$refs.invoice.init({})
        this.$refs.invoice.dialogVisible = true
      })
    },
    removeInvoice(data) {
       this.$confirm('此操作将删除发票抬头, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
                deleteInvoiceByTaxNumber({
          id: data.id,
        }).then(res => {
          if(res.code === 200){
            this.$message.success('删除成功！')
               this.getDataList()
          } 
      })
      })

    },
  },
  beforeMount() {
    this.getDataList()
  },
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  padding-top: 30px;
}
.el-scrollbar {
  height: 100%;
}
>>> .el-scrollbar__wrap {
  height: calc(100% + 15px);
}
.cardInfo {
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  padding: 8px;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
.cardInfoItem .el-card.active {
  border-left: 10px solid #3b85f4;
}
.cardInfoItem {
  margin: 6px;
  position: relative;
  width: calc(33.33% - 12px);

  .el-card {
    border-radius: 8px;
    overflow: hidden;
    &:hover {
      box-shadow: 0 4px 20px rgba(22, 101, 216, 0.2);
      border-color: #1665d8;

      .go-detail {
        bottom: 12px;
      }
    }
  }
  >>> .el-card__body {
    padding: 16px 24px;
    position: relative;
  }
}
.itemempty {
  height: 0;
  width: calc(33.3% - 12px);
}
@media screen and (max-width: 1280px) {
  .cardInfoItem {
    position: relative;
    width: calc(50% - 12px);
  }
  .itemempty {
    height: 0;
    width: calc(50% - 12px);
  }
}
.titleLabel {
  display: inline-block;
  font-size: 14px;
  color: #999999;
  margin-right: 20px;
  width: 70px;
  font-family: PingFangSC-Regular;
}
.invoiceTitle {
  font-family: PingFangSC-Medium;
}
</style>
